<form [formGroup]="registerForm">
    <h1>Registrieren</h1>
    <div class="mdc-layout-grid__inner">
        <mat-form-field appearance="outline" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-12-phone">
            <mat-label>Vorname</mat-label>
            <input matInput formControlName="firstname" required placeholder="Vorname">
        </mat-form-field>

        <mat-form-field appearance="outline" class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-12-phone">
            <mat-label>Nachname</mat-label>
            <input matInput formControlName="secondname" required placeholder="Nachname">
        </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full_width">
        <mat-label>E-Mail Adresse</mat-label>
        <input matInput email type="email" formControlName="email" required placeholder="E-Mail Adresse">
    </mat-form-field>
    <div *ngIf="!registerForm.get('email').valid">
        <span *ngIf="registerForm.get('email').hasError('existing')">Der Benutzer existiert bereits.</span>
    </div>

    <mat-form-field appearance="outline" class="full_width">
        <mat-label>Telefonnummer</mat-label>
        <input matInput phone formControlName="phone" required placeholder="Telefonnummer">
    </mat-form-field>

    <single-password-input (passwordValidAndChanged)="passwordChanged($event)"></single-password-input>

    <mat-checkbox color="primary" formControlName="dsgvoCheckbox">
        <div>Ich habe die <a href="/datenschutz" target="_blank">Datenschutzerklärung</a> gelesen und bin damit einverstanden.</div>
    </mat-checkbox>

    <div class="button-container">
        <button matRipple  mat-flat-button color="primary" *ngIf="showRegisterButton" [disabled]="!registerForm.valid" (click)="executeImportantAction()">
            <mat-icon aria-hidden="false">lock</mat-icon>Registrieren
        </button>
        <re-captcha #registerCaptcha *ngIf="showV2Captcha" (resolved)="resolvedV2($event)" siteKey="6Lcy88QZAAAAAPz1D7oYXsuJidA7ZBTuQ00-KTKO"></re-captcha>
    </div>
</form>
<div class="subtext">Du hast schon einen Account? Dann kannst du <a href="#" (click)="goBack()">hier</a> zurück zum Login.</div>